var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"header-payout",attrs:{"lg":"4"}},[(_vm.hasPacket)?_c('router-link',{staticClass:"button--primary",attrs:{"to":{ name: 'Payout' }}},[_vm._v("Payout")]):_c('button',{staticClass:"button--primary",attrs:{"disabled":true,"type":'button'}},[_vm._v("\n        Payout\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71ef12f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/header/bottombar/HeaderPayout.vue
// module id = ECUB
// module chunks = 0